<template>
  <v-app>
    <v-app-bar app color="white" dense class="d-print-none">
      <!-- color="white" dark -->
      <div class="d-flex align-center">
        <v-img
          alt="Flotex"
          :src="require('@/assets/images/logo-horiz-orange-navy.svg')"
          width="230px"
        />
        <template v-if="isDevel">
          <v-img alt="" :src="require('@/assets/images/sign_devel.png')" />
        </template>
        <template v-if="isStaging">
          <v-img alt="" :src="require('@/assets/images/sign_staging.png')" />
        </template>
      </div>

      <!-- <v-toolbar-title>Page title</v-toolbar-title> -->

      <v-spacer />

      <!-- <div class="d-flex d-sm-none d-md-flex align-center app-bar-container__representative"> -->
      <div
        v-if="blankRepresentative"
        class="d-flex align-center app-bar-container__representative"
      >
        <div class="red--text text--darken-3 mr-2">
          <p>Potrzebujesz pomocy?</p>
          <p>Dzwoń!</p>
        </div>
        <div class="representative-data mr-2">
          <p>
            <a class="mr-3" :href="'mailto:' + blankRepresentative.email">
              {{ blankRepresentative.name }}
            </a>
          </p>
          <p>
            <span>tel. {{ blankRepresentative.mobile }}</span>
          </p>
        </div>
      </div>

      <div
        v-if="blankNumber"
        class="d-flex align-center app-bar-container__blank-number"
      >
        <div>
          <p>Wniosek&nbsp;numer</p>
          <p>{{ blankNumber }}</p>
        </div>
      </div>

      <v-menu
        v-if="blankToken"
        v-model="optionsMenu"
        transition="slide-y-transition"
        bottom
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template #activator="{ on }">
          <v-btn text v-on="on">
            <v-icon class="red--text text--darken-3"> mdi-handshake </v-icon>
            <span
              v-show="$vuetify.breakpoint.width >= 840"
              class="red--text text--darken-3"
              >Pliki</span
            >
            <span
              v-show="$vuetify.breakpoint.width < 840"
              class="red--text text--darken-3"
              >Kontakt</span
            >
          </v-btn>
        </template>

        <v-card>
          <v-list-item>
            <v-list-item-icon>
              <!-- <v-icon color="indigo darken-2">mdi-phone</v-icon> -->
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title
                >Wniosek numer {{ blankNumber }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="blankRepresentative" inset />

          <BlankRepresentative :btn-close="true" @close="optionsMenu = false" />

          <v-divider v-if="blankRepresentative" inset />

          <BlankPublicFiles />

          <v-divider inset />

          <!-- <v-list>
            <v-subheader>Ustawienia</v-subheader>

            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="layoutH" />
              </v-list-item-action>
              <v-list-item-title>Układ horyzontalny</v-list-item-title>
            </v-list-item>
          </v-list> -->
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <template v-if="hasError">
          <ErrorNetwork v-if="errorNetwork" />
          <Error500 v-else-if="error5xx" />
          <!-- <Error404 v-else-if="error404 || (!isLoading && !tokenFromUrl)"></Error404> -->
          <Error404 v-else />
        </template>
        <template v-if="!hasError">
          <Loading :loading="!blankToken && isLoading" />
          <BlankView v-if="blankToken" />
        </template>
        <v-btn
          v-if="previewButtonVisible()"
          icon
          color="red"
          elevation="6"
          fab
          small
          class="btn-preview"
          @click="requestPreview"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import BlankView from '@/view/Blank'
import BlankRepresentative from '@/components/Blank/BlankRepresentative'
import BlankPublicFiles from '@/components/Blank/BlankPublicFiles'
import ErrorNetwork from '@/view/ErrorNetwork'
import Error500 from '@/view/Error500'
import Error404 from '@/view/Error404'
import Loading from '@/components/Loading'
import { get, call } from 'vuex-pathify'
// import { sync, get, call } from 'vuex-pathify'
import { client } from '@/api/ClientContainer'
import EventBus from '@/services/EventBus'

export default {
  name: 'App',

  components: {
    BlankView,
    Loading,
    Error404,
    Error500,
    ErrorNetwork,
    BlankRepresentative,
    BlankPublicFiles
  },

  data: () => ({
    optionsMenu: false
  }),

  computed: {
    // layoutH: sync('layoutH'),
    hasError: get('error/hasError'),
    errorNetwork: get('error/errorNetwork'),
    error404: get('error/error404'),
    error5xx: get('error/error5xx'),
    loadingCount: get('loader/loading'),
    isLoading() {
      return this.loadingCount > 0
    },
    blankToken: get('blank/data@token'),
    blankRepresentative: get('blank/data@representative'),
    blankNumber: get('blank/data@number'),
    currentStep: get('blank/data@currentStep'),
    tokenFromUrl() {
      return this.getTokenFromUrl()
    },
    isDevel() {
      return process.env.VUE_APP_HOST == 'devel'
    },
    isStaging() {
      return process.env.VUE_APP_HOST == 'staging'
    }
  },

  created: function () {
    this.loadDictionaries()
    this.loadBlank(this.getTokenFromUrl())
    this.loadPackages()
  },

  methods: {
    // ...call('dictionary/loadAll'),
    loadDictionaries: call('dictionary/loadAll'),
    loadBlank: call('blank/load'),
    loadPackages: call('packages/load'),
    getTokenFromUrl() {
      let url = new URL(window.location.href)
      let token = url.pathname.substring(1)
      // Na produkcji kod musi być brany z ID
      if (url.searchParams.get('id')) {
        token = url.searchParams.get('id')
      }

      // Token missing or unknown format
      const tokenMatchOldFormat =
        token && token.match(/^[a-f0-9]{13}$/) !== null
      const tokenMatchNewFormat =
        token && token.match(/^[0-9a-fA-F-]{36}$/) !== null
      if (!tokenMatchOldFormat && !tokenMatchNewFormat) {
        token = null
      }

      this.initMercure(token)

      return token
    },
    requestPreview() {
      client.blankPreview.request(this.blankToken)
    },
    previewButtonVisible() {
      return (
        this.currentStep == 5 &&
        JSON.parse(window.sessionStorage.getItem('blank.preview'))
      )
    },
    // Initialize MERCURE
    // Check if mercure config is available
    initMercure(token) {
      let mercureConfig = {
        hubUrl: process.env.VUE_APP_MERCURE_URL,
        topics: [
          // '*',
          'blank-preview/' + token
        ]
      }
      // console.log(mercureConfig)
      if (
        typeof mercureConfig == 'undefined' ||
        typeof mercureConfig.hubUrl == 'undefined' ||
        mercureConfig.hubUrl == null
      ) {
        return
      }

      // Prepare mercure URL
      // Mercure 1.0: "?topic=" (RFC 6570) no longer exists — the built
      // "blank-preview/<token>" topic is an exact topic, so it uses "match".
      const mercureUrl = new URL(mercureConfig.hubUrl)
      for (var i = 0; i < mercureConfig.topics.length; i++) {
        mercureUrl.searchParams.append('match', mercureConfig.topics[i])
      }
      // console.log(mercureUrl)
      let vueComponent = this
      // Start listening for events from mercure
      const eventSource = new EventSource(mercureUrl, { withCredentials: true })
      // const eventSource = new EventSource(mercureUrl);
      eventSource.onmessage = function ({ message }) {
        // console.log(['mercureEvent', data])
        let dataOb = null
        try {
          dataOb = JSON.parse(message).data
          // console.log(['mercureData', dataOb])

          // Request message
          if (
            !!dataOb.token &&
            dataOb.token === vueComponent.blankToken &&
            dataOb.action === 'request' &&
            !vueComponent.previewButtonVisible()
          ) {
            EventBus.$emit('BLANK_PREVIEW_REQUEST', dataOb)
          }

          // Reply message
          if (
            dataOb.action === 'reply' &&
            vueComponent.previewButtonVisible()
          ) {
            // console.log(dataOb.payload.formData)
            // call('setData', dataOb.payload.formData)
            EventBus.$emit('BLANK_PREVIEW_REPLY', dataOb.payload)
          }
        } catch (e) {
          return false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn-preview {
  top: -50px;
  z-index: 1;
  background-color: white;
  float: right;
  margin-right: 20px;
}
</style>
